exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".avatar-list{margin:0;padding:0;list-style:none}.avatar-list__item:not(:first-child){margin-top:33.333333333333336px}@media screen and (min-width:768px){.avatar-list__item:not(:first-child){margin-top:25px}}.avatar-list__item__avatar{width:150px;height:150px;margin:0 auto 12.5px;border-radius:50%;overflow:hidden}@media screen and (min-width:768px){.avatar-list__item__avatar{float:left;margin:0}}.avatar-list__item__avatar img{width:100%}.avatar-list__item__text{min-height:150px}@media screen and (min-width:768px){.avatar-list__item__text{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;min-height:150px;margin-left:180px}}@media screen and (min-width:768px){.avatar-list__item__text p{font-size:1.6rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/avatar-list/avatar-list.styl
// module id = 495
// module chunks = 0